export default "__VITE_ASSET__DDjNLmlp__"